import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo, useMemo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

export enum ID_REGISTER {
  NASCITA = '1',
  MORTE = '2',
  MATRIMONIO = '3',
  UNIONE_CIVILE = '4',
  CITTADINANZA = '5',
}

const list: Array<ItemVM> = [
  {
    id: ID_REGISTER.NASCITA,
    value: 'Nascita',
  },
  {
    id: ID_REGISTER.MORTE,
    value: 'Morte',
  },
  {
    id: ID_REGISTER.MATRIMONIO,
    value: 'Matrimonio',
  },
  {
    id: ID_REGISTER.UNIONE_CIVILE,
    value: 'Unione Civile',
  },
  {
    id: ID_REGISTER.CITTADINANZA,
    value: 'Cittadinanza',
  },
];

const listWithNessuno: Array<ItemVM> = [
  {
    id: '',
    value: 'Nessuno',
  },
  {
    id: ID_REGISTER.NASCITA,
    value: 'Nascita',
  },
  {
    id: ID_REGISTER.MORTE,
    value: 'Morte',
  },
  {
    id: ID_REGISTER.MATRIMONIO,
    value: 'Matrimonio',
  },
  {
    id: ID_REGISTER.UNIONE_CIVILE,
    value: 'Unione Civile',
  },
  {
    id: ID_REGISTER.CITTADINANZA,
    value: 'Cittadinanza',
  },
];

export const getNameRegister = (id?: string): string => {
  return list.find((item) => item.id === id)?.value || '';
};

interface ListRegisterProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  withNessuno?: boolean;
  label?: string;
  required?: boolean;
}

const ListRegisterComponent = ({
  disabled,
  onChange,
  value,
  error,
  withNessuno,
  label = 'Registro',
  required,
}: ListRegisterProps): React.ReactElement => {
  const listData: Array<ItemVM> = useMemo(() => {
    if (withNessuno) {
      return listWithNessuno;
    }
    return list;
  }, [withNessuno]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel id="state-list-label">{`${label} ${required ? '*' : ''}`}</InputLabel>
      <PmiSelect
        labelId="state-list-label"
        id="state-list"
        name="state-list"
        value={value}
        label={`${label} ${required ? '*' : ''}`}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {listData?.map((state: ItemVM) => (
          <MenuItem key={state.id} value={state.id}>
            {state.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListRegisterComponent.displayName = 'List register component';

const ListRegister = memo(ListRegisterComponent);

export default ListRegister as typeof ListRegisterComponent;
